import React from 'react';
import { Modal, Button } from 'antd';
import { CloseIcon } from '../../assets/icons';
import { Images } from '../../config/images';
import './SuccessModal.scss';
import { LazyLoadImage } from 'react-lazy-load-image-component';

const SuccessModal = ({
  title = 'You’re all set.',
  description = 'Your updates have been saved successfully.',
  buttonText = 'Done',
  loading = false,
  ...props
}) => {
  return (
    <Modal className='success' open={props.setOpen} onCancel={props.setClose} closeIcon={<CloseIcon />} footer={false} width={524} centered>
      <div className='mb-16 success__vector'>
        <LazyLoadImage src={Images.success} alt='success vector art' />
      </div>
      <h4 className='success__title mb-16'>{title}</h4>
      <p className='mb-48 text-taupe w-100'>{description}</p>
      <Button loading={loading} type='primary' className='w-100' onClick={props.setDone}>
        {buttonText}
      </Button>
    </Modal>
  );
};

export default SuccessModal;
